import React, { Component } from "react";
import { Route } from "react-router-dom";
import loadable from "@loadable/component";

import Login from "modules/auth/components/Login";

const AsyncPage = loadable(
  (props) => {
    switch (props.module) {
      case "master-data":
        return import(
          `modules/master-data/${props.sub_module}/components/Overview`
        );
      case "dashboard":
        return import(
          `modules/dashboard/${props.sub_module}/components/Overview`
        );
      case "sale-order":
        return import(
          `modules/sale-order/${props.sub_module}/components/Overview`
        );
      case "product-management":
        return import(
          `modules/product-management/${props.sub_module}/components/Overview`
        );
      case "report":
          return import(
            `modules/report/${props.sub_module}/components/Overview`
          );
      default:
        break;
    }
  },
  {
    cacheKey: (props) => props.page,
  }
);

class PrivateRoute extends Component {
  checkRoute = () => {
    const {
      value: { module, sub_module, path },
      done,
      value,
    } = this.props;
    if (done === true) {
        return (
          <Route
            component={(props) => <AsyncPage
              module={module}
              sub_module={sub_module}
              value={value}
              {...props} />
            }
            path={path}
          />
        );
    } else {
      return <Route exact path="/" component={Login} />;
    }
  };

  render() {
    return this.checkRoute();
  }
}

export default PrivateRoute;
